export function formatName(input: string) {
  if (!input || typeof input !== 'string') return '';

  const parts = input.trim().split(/\s+/);
  const firstName = parts[0];

  const secondInitial = parts
    .slice(1)
    .map(word => word[0])
    .find(char => /[A-Za-z]/.test(char));

  return secondInitial ? `${firstName} ${secondInitial.toUpperCase()}.` : firstName;
}